import React from "react";
import { useEffect, useState } from "react";
import axiosClient from "../axios-client.js";
import _ from "lodash";
import moment from "../js/moment-config.js";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import swal from "sweetalert";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import RideSeats from "../components/RideSeats";
import TrainSeats from "../components/TrainSeats";

const DetallesClase = () => {
  const [classDetails, setClass] = useState({
    class: {
      coach_name: "",
    },
    seats: [],
  });
  const [seatDetails, setSeat] = useState(0);

  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingRes, setLoadingRes] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false); // Estado para el rol
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    getClassDetails();
    checkAdminRole(); // 👈 Llama a la función de verificación de rol
  }, []); // --- Lógica de Administración ---

  const checkAdminRole = () => {
    // ASUMO que el objeto user tiene una propiedad 'role' y que el valor 'admin' lo identifica
    const user = JSON.parse(localStorage.getItem("USER_DATA"));
    if (user && user.role === "admin") {
      setIsAdmin(true);
    } else {
      setIsAdmin(false);
    }
  };
  const handleCancelarClase = () => {
    swal({
      title: "¿Estás seguro de cancelar la clase?",
      text: "Esta acción es irreversible, devolverá los créditos y notificará a los usuarios.",
      icon: "warning",
      buttons: ["No, mantener", "Sí, cancelar"],
      dangerMode: true,
    }).then((willCancel) => {
      if (willCancel) {
        setLoading(true); // O puedes usar un estado de loading dedicado para acciones de admin
        axiosClient
          .post(`/clases/${id}/cancelar`)
          .then(({ data }) => {
            swal("¡Clase Cancelada!", data.message, "success"); // Opcional: Redirigir o recargar la página para ver el cambio de estado
            navigate("/reservar-clases");
          })
          .catch((error) => {
            const errorMessage =
              error.response?.data?.error ||
              "Hubo un error al cancelar la clase.";
            swal("Error", errorMessage, "error");
          })
          .finally(() => {
            setLoading(false);
          });
      }
    });
  };

  const handleNotificarCoach = () => {
    swal({
      title: "¿Enviar notificación de cambio de Coach?",
      text: "Esto enviará un correo electrónico a todos los usuarios con reserva.",
      icon: "info",
      buttons: ["No, cerrar", "Sí, notificar"],
    }).then((willNotify) => {
      if (willNotify) {
        setLoading(true);
        axiosClient
          .post(`/clases/${id}/notificacion-coach`)
          .then(({ data }) => {
            swal("¡Notificación Enviada!", data.message, "success");
          })
          .catch((error) => {
            const errorMessage =
              error.response?.data?.error ||
              "Hubo un error al enviar la notificación.";
            swal("Error", errorMessage, "error");
          })
          .finally(() => {
            setLoading(false);
          });
      }
    });
  };

  const getClassDetails = () => {
    setLoading(true);
    axiosClient
      .get(`/classes/${id}`)
      .then(({ data }) => {
        setClass(data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleClose = () => {
    setSeat(0);
    setShow(false);
  };

  const handleShow = (seat) => {
    setSeat(seat);
    setShow(true);
  };

  const reservarLugar = (seat) => {
    setLoadingRes(true);
    const user = JSON.parse(localStorage.getItem("USER_DATA"));
    if (!user) {
      swal({
        title: "Error",
        text: "Ocupa crear un usuario y contar con un paquete de clases para poder reservar",
        icon: "error",
      }).then(() => {
        navigate("/auth/signup");
      });
    }

    const reservation = {
      class_id: classDetails.class.id,
      user_id: user.id,
      bike_number: seat,
      status: "Reservada",
      validated: 0,
    };

    axiosClient
      .post(`/reservations`, reservation)
      .then(({ data }) => {
        handleClose();
        swal({
          title: "Reservacion exitosa",
          text: "Gracias",
          icon: "success",
        });
        const updatedSeats = classDetails.seats.map((s) => {
          if (s.seat_number === seat) {
            return {
              ...s,
              status: 1,
            };
          }
          return s;
        });
        setClass((prevClass) => ({
          ...prevClass,
          seats: updatedSeats,
        }));
        setLoadingRes(false);
        navigate("/mis-clases");
      })
      .catch((error) => {
        const err = JSON.parse(error.request.response);
        handleClose();
        setLoadingRes(false);
        swal({
          title: "Error",
          text: err.message,
          icon: "error",
        }).then(() => {
          navigate("/reservar-clases");
        });
      });
  };

  return (
    <div className="ps-4 pe-4">
      <div className="mt-5 mb-4">
        <p className="calendario-titulo">Reserva en línea</p>
      </div>

      {loading && !classDetails.class ? (
        <div className="loading-container center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <div className="row">
          <div className="col-lg-3 detalle-clase">
            {isAdmin && (
              <div className="mt-4 d-grid gap-2">
                <Button
                  variant="danger"
                  onClick={handleCancelarClase}
                  disabled={loading}
                >
                  Cancelar Clase 🚫
                </Button>
                <Button
                  variant="warning"
                  onClick={handleNotificarCoach}
                  disabled={loading}
                >
                Notificar Cambio de Coach 📣
                </Button>
              </div>
            )}
            <p>
              <span className="bold">Hora de la clase:</span>{" "}
              {classDetails.class.class_time}
            </p>
            <p>
              <span className="bold">Fecha:</span>{" "}
              {classDetails.class.class_date}
            </p>
            <p>
              <span className="bold">Duración: </span>
              {classDetails.class.duration} Minutos
            </p>
            <p className="texto-bola">
              <span className="bold">Lugares Disponibles:</span>
              <span
                className={`bola-seat info ${
                  classDetails.class.type_class == "Train" ? "bola-roja" : ""
                }`}
              ></span>
            </p>
            <p className="texto-bola">
              <span className="bold ">Lugares Ocupados:</span>
              <span className="bola-seat ocupado info"></span>
            </p>
          </div>

          <div className="col-lg-9">
            {classDetails.class.type_class === "Train" ? (
              <TrainSeats classDetails={classDetails} handleShow={handleShow} />
            ) : (
              <RideSeats classDetails={classDetails} handleShow={handleShow} />
            )}
          </div>
        </div>
      )}

      <Modal className="modal fade" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmación de lugar</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            ¿Esta seguro de reservar el lugar <strong>{seatDetails}</strong>{" "}
            para el día: <strong>{classDetails.class.class_date}</strong> -{" "}
            <strong>{classDetails.class.class_time}</strong>?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => reservarLugar(seatDetails)}
            disabled={loadingRes}
          >
            Reservar
          </Button>
          <Button
            variant="secondary"
            onClick={handleClose}
            disabled={loadingRes}
          >
            Cancelar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default DetallesClase;
